import apiService from './apiService';

class FavoriteService {
  // Kedvenc hozzáadása
  async addFavorite(providerId) {
    try {
      const response = await apiService.post('/favorites', { providerId });
      return response;
    } catch (error) {
      console.error('Kedvenc hozzáadása hiba:', error);
      throw error;
    }
  }

  // Kedvenc eltávolítása
  async removeFavorite(providerId) {
    try {
      const response = await apiService.delete(`/favorites/${providerId}`);
      return response;
    } catch (error) {
      console.error('Kedvenc eltávolítása hiba:', error);
      throw error;
    }
  }

  // Felhasználó kedvencei
  async getUserFavorites(page = 1, limit = 10) {
    try {
      const response = await apiService.get(`/favorites?page=${page}&limit=${limit}`);
      return response;
    } catch (error) {
      console.error('Kedvencek lekérése hiba:', error);
      throw error;
    }
  }

  // Kedvenc státusz ellenőrzése
  async checkFavoriteStatus(providerId) {
    try {
      const response = await apiService.get(`/favorites/check/${providerId}`);
      return response;
    } catch (error) {
      console.error('Kedvenc státusz ellenőrzése hiba:', error);
      throw error;
    }
  }

  // Kedvenc toggle (hozzáad vagy eltávolít)
  async toggleFavorite(providerId) {
    try {
      const statusResponse = await this.checkFavoriteStatus(providerId);
      
      if (statusResponse.isFavorite) {
        await this.removeFavorite(providerId);
        return { isFavorite: false, action: 'removed' };
      } else {
        await this.addFavorite(providerId);
        return { isFavorite: true, action: 'added' };
      }
    } catch (error) {
      console.error('Kedvenc toggle hiba:', error);
      throw error;
    }
  }
}

export default new FavoriteService();